'use client';

import { c as _c } from "react/compiler-runtime";
import { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPencil, faRulerHorizontal, faSwatchbook, faClock } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import ShippingPolicyModal from './ShippingPolicyModal';
const ProductAttributesCard = t0 => {
  const $ = _c(50);
  const {
    sub_product,
    attributes,
    optionsCompleted,
    variant,
    calculatedLeadTime
  } = t0;
  const [isShippingModalOpen, setIsShippingModalOpen] = useState(false);
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[0] !== attributes || $[1] !== calculatedLeadTime || $[2] !== optionsCompleted || $[3] !== sub_product.detail_line_1 || $[4] !== sub_product.detail_line_2 || $[5] !== sub_product.detail_line_3 || $[6] !== sub_product.lead_time || $[7] !== sub_product.product_dimensions || $[8] !== variant?.lead_time) {
    const attributesWithIcons = (attributes || []).filter(_temp).slice(0, 4);
    const shippingTime = optionsCompleted ? calculatedLeadTime || variant?.lead_time || sub_product.lead_time : "Select options for shipping time";
    t7 = "mb-6 lg:mb-0 lg:mt-10";
    t1 = "p-6 bg-gray-3 rounded";
    let t8;
    if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <dt className="flex items-start text-sm font-medium mb-1"><span className="shrink-0 w-8" aria-hidden="true"><FontAwesomeIcon icon={faPencil} className="text-lg text-light" /></span><span>Design + Manufacturing</span></dt>;
      $[16] = t8;
    } else {
      t8 = $[16];
    }
    let t9;
    if ($[17] !== sub_product.detail_line_1) {
      t9 = <dd className="text-xs whitespace-pre-line ml-8">{sub_product.detail_line_1}</dd>;
      $[17] = sub_product.detail_line_1;
      $[18] = t9;
    } else {
      t9 = $[18];
    }
    let t10;
    if ($[19] !== sub_product.detail_line_3) {
      t10 = sub_product.detail_line_3 && <dd className="text-xs whitespace-pre-line ml-8">{sub_product.detail_line_3}</dd>;
      $[19] = sub_product.detail_line_3;
      $[20] = t10;
    } else {
      t10 = $[20];
    }
    if ($[21] !== t10 || $[22] !== t9) {
      t2 = <div className="mb-6">{t8}{t9}{t10}</div>;
      $[21] = t10;
      $[22] = t9;
      $[23] = t2;
    } else {
      t2 = $[23];
    }
    let t11;
    if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
      t11 = <dt className="flex items-start text-sm font-medium mb-1"><span className="shrink-0 w-8" aria-hidden="true"><FontAwesomeIcon icon={faRulerHorizontal} className="text-lg text-light" /></span><span>Dimensions</span></dt>;
      $[24] = t11;
    } else {
      t11 = $[24];
    }
    if ($[25] !== sub_product.product_dimensions) {
      t3 = <div className="mb-6">{t11}<dd className="text-xs whitespace-pre-line ml-8">{sub_product.product_dimensions}</dd></div>;
      $[25] = sub_product.product_dimensions;
      $[26] = t3;
    } else {
      t3 = $[26];
    }
    let t12;
    if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
      t12 = <dt className="flex items-start text-sm font-medium mb-1"><span className="shrink-0 w-8" aria-hidden="true"><FontAwesomeIcon icon={faSwatchbook} className="text-lg text-light" /></span><span>Materials</span></dt>;
      $[27] = t12;
    } else {
      t12 = $[27];
    }
    if ($[28] !== sub_product.detail_line_2) {
      t4 = <div className="mb-6">{t12}<dd className="text-xs whitespace-pre-line ml-8">{sub_product.detail_line_2}</dd></div>;
      $[28] = sub_product.detail_line_2;
      $[29] = t4;
    } else {
      t4 = $[29];
    }
    const t13 = attributesWithIcons.length > 0 ? "mb-6" : "";
    let t14;
    if ($[30] === Symbol.for("react.memo_cache_sentinel")) {
      t14 = <dt className="flex items-start text-sm font-medium mb-1"><span className="shrink-0 w-8" aria-hidden="true"><FontAwesomeIcon icon={faClock} className="text-lg text-light" /></span><span>Shipping Time</span></dt>;
      $[30] = t14;
    } else {
      t14 = $[30];
    }
    const t15 = `text-xs whitespace-pre-line ml-8 capitalize leading-[1] ${!optionsCompleted ? "text-light" : ""}`;
    let t16;
    if ($[31] !== shippingTime || $[32] !== t15) {
      t16 = <dd className={t15}>{shippingTime}</dd>;
      $[31] = shippingTime;
      $[32] = t15;
      $[33] = t16;
    } else {
      t16 = $[33];
    }
    if ($[34] !== t13 || $[35] !== t16) {
      t5 = <div className={t13}>{t14}{t16}</div>;
      $[34] = t13;
      $[35] = t16;
      $[36] = t5;
    } else {
      t5 = $[36];
    }
    t6 = attributesWithIcons.map((attribute, index) => <div key={index} className={index < attributesWithIcons.length - 1 ? "mb-6" : ""}><dt className="flex items-start text-sm font-medium capitalize"><span className="shrink-0 w-8 text-lg text-light [&>svg]:w-[1em] [&>svg]:h-[1em] [&>svg]:fill-current" aria-hidden="true" dangerouslySetInnerHTML={{
          __html: attribute.icon_svg
        }} /><span>{attribute.tag_name}</span></dt>{attribute.description && <dd className="text-xs whitespace-pre-line ml-8">{attribute.description}</dd>}</div>);
    $[0] = attributes;
    $[1] = calculatedLeadTime;
    $[2] = optionsCompleted;
    $[3] = sub_product.detail_line_1;
    $[4] = sub_product.detail_line_2;
    $[5] = sub_product.detail_line_3;
    $[6] = sub_product.lead_time;
    $[7] = sub_product.product_dimensions;
    $[8] = variant?.lead_time;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t1 = $[9];
    t2 = $[10];
    t3 = $[11];
    t4 = $[12];
    t5 = $[13];
    t6 = $[14];
    t7 = $[15];
  }
  let t8;
  if ($[37] !== t1 || $[38] !== t2 || $[39] !== t3 || $[40] !== t4 || $[41] !== t5 || $[42] !== t6) {
    t8 = <dl className={t1}>{t2}{t3}{t4}{t5}{t6}</dl>;
    $[37] = t1;
    $[38] = t2;
    $[39] = t3;
    $[40] = t4;
    $[41] = t5;
    $[42] = t6;
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] !== isShippingModalOpen) {
    t9 = <ShippingPolicyModal isOpen={isShippingModalOpen} setIsOpen={setIsShippingModalOpen} />;
    $[44] = isShippingModalOpen;
    $[45] = t9;
  } else {
    t9 = $[45];
  }
  let t10;
  if ($[46] !== t7 || $[47] !== t8 || $[48] !== t9) {
    t10 = <div className={t7}>{t8}{t9}</div>;
    $[46] = t7;
    $[47] = t8;
    $[48] = t9;
    $[49] = t10;
  } else {
    t10 = $[49];
  }
  return t10;
};
export default ProductAttributesCard;
function _temp(attr) {
  return attr.icon_svg;
}